<section class="order-container" id="mplactiva-order">
  <div class="row">
    <div class="row">
      <div class="left">
        <div class="title-name">Títulos</div>
      </div>
      <div class="right">
        <div class="title-name disabled">Duración</div>
      </div>
    </div>
    <div
      punchPicker
      [placeholder]="'Títulos'"
      [isTitles]="true"
      (items)="setTitles($event)"
      [sentValue]="titles"
      [minValue]="minTitles"
      data-recording-sensitive
    ></div>
    <div class="hard-section">
      <div class="subtitle">1 día</div>
    </div>
  </div>
  <div class="row">
    <div class="row">
      <div class="left">
        <div class="title-name">Puja</div>
      </div>
      <div class="right max-price">
        <div class="title-name">Precio Máximo</div>
      </div>
    </div>
    <div
      [class]="'puja'"
      class="puja"
      [placeholder]="'Puja'"
      [maxValue]="900"
      [minValue]="1"
      punchPicker
      (items)="setPuja($event)"
      data-recording-sensitive
    ></div>
    <div
      [class]="'prc-max'"
      class="prc-max"
      [isPrice]="true"
      [placeholder]="'Prc. máximo'"
      [sentValue]="selectedPrice"
      punchPicker
      (items)="setMaxPrice($event)"
      [minValue]="0"
      data-recording-sensitive
    ></div>
  </div>
  <div class="actions" *ngIf="canOperate && !isDiscretional">
    <button (click)="tryBuy()" class="btn-compra">
      <div class="button button--loading" *ngIf="isBuyButtonLoading">
        <div class="button__loader">
          <div class="dot"></div>
          <div class="dot"></div>
          <div class="dot"></div>
        </div>
      </div>
      {{ isBuyButtonLoading ? '' : 'Comprar' }}
    </button>
    <button (click)="trySell()" class="btn-venta">
      <div class="button button--loading" *ngIf="isSellButtonLoading">
        <div class="button__loader">
          <div class="dot"></div>
          <div class="dot"></div>
          <div class="dot"></div>
        </div>
      </div>
      {{ isSellButtonLoading ? '' : 'Vender' }}
    </button>
  </div>
</section>
<app-confirmation-modal
  [order]="confirmationOrder"
  (onClose)="cancelConfirmation()"
  (confirmationHandler)="registerOrder()"
  *ngIf="showConfirmation"
>
</app-confirmation-modal>
